import {useCallback} from 'react'

type UseAgentAssignmentCompleteOptions = {
  onIssueUpdate?: () => void
}

export function useAgentAssignmentComplete({onIssueUpdate}: UseAgentAssignmentCompleteOptions) {
  return useCallback(() => {
    onIssueUpdate?.()
  }, [onIssueUpdate])
}
